import React from 'react';
import './FormStyles.css';
import StepDrawer from './StepDrawer';

function DemographicInfo({ saving, onSubmit, currentStep, totalSteps, onBack, onCancel, formData, setFormData }) {
  const handleDateChange = (e) => {
    setFormData(prev => ({
      ...prev,
      surgeryDate: e.target.value
    }))
  };

  const isDateValid = () => {
    if (!formData.surgeryDate) return false;
    
    const date = new Date(formData.surgeryDate);
    const today = new Date();
    
    if (isNaN(date.getTime())) return false;
    
    if (date < new Date(0)) return false;
    
    if (date > today) return false;
    
    return true;
  };

  return (
    <StepDrawer
      currentStep={currentStep}
      totalSteps={totalSteps}
      onCancel={onCancel}
      onContinue={onSubmit}
      title="When did you have your surgery?"
      onBack={onBack}
      disabled={!isDateValid() || saving}
    >
      <form onSubmit={onSubmit} className="form-content">
        <div className="form-row">
          <label>Date of Surgery:</label>
          <input
            type="date"
            value={formData.surgeryDate}
            onChange={handleDateChange}
            required
            max={new Date().toISOString().split('T')[0]}
          />
        </div>
        <button type="submit" style={{ display: 'none' }} aria-hidden="true" disabled={!isDateValid() || saving}/>
      </form>
    </StepDrawer>
  );
}

export default DemographicInfo; 